import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

const noImage = `<img src="${STATIC_BASE_URL}/static/webapp/icons/unknown.svg">`

const STORYBOOK_STATIC_ORIGIN = 'https://members.ironstaging.ironscales.com'
const MAP_PATHS_BY_TYPE = {
  stroke: (imageName) =>
    `${window.IS_STORYBOOK ? STORYBOOK_STATIC_ORIGIN : STATIC_BASE_URL}/static/webapp/icons/${imageName}.svg`,
  fill: (imageName) =>
    `${window.IS_STORYBOOK ? STORYBOOK_STATIC_ORIGIN : STATIC_BASE_URL}/static/webapp/icons/fill/${imageName}.svg`,
}
const Icon = ({ id, className, testId, onClick, imageName, title, fillType = 'stroke' }) => {
  const [data, setData] = useState(null)

  const createMarkup = (str) => ({
    __html: str,
  })

  useEffect(() => {
    // Per-run flag: a flag shared across runs is tripped by StrictMode's mount/cleanup/mount.
    let cancelled = false

    const load = async () => {
      let layoutImage

      try {
        const response = await fetch(MAP_PATHS_BY_TYPE[fillType](imageName))

        layoutImage = response.status !== 200 ? noImage : await response.text()
      } catch (e) {
        layoutImage = noImage
      }

      if (!cancelled) setData(layoutImage)
    }

    load()

    return () => {
      cancelled = true
    }
  }, [imageName, fillType])

  return (
    <span
      id={id}
      data-testid={testId}
      className={className}
      onClick={onClick}
      dangerouslySetInnerHTML={createMarkup(data)}
      title={title}
    />
  )
}

/**
 * @deprecated please use DesignSystem/Icons instead.
 */

export default styled(Icon).attrs((props) => ({
  id: props.id || 'icon',
}))`
  display: inline-flex;
  align-items: center;

  &:hover {
    cursor: ${function (props) {
      return props.onClick || props.hoverFill ? 'pointer' : 'unset'
    }};
    svg,
    svg > path {
      fill: ${(props) => (props.hoverFill ? props.hoverFill : props.fill)};
    }
  }

  svg,
  svg > path {
    height: ${(props) => props.size || props.height} !important;
    fill: ${(props) => props.fill || 'currentColor'};
    // need to remove table design, icons get affected by css on svg
    width: ${(props) => props.size || props.width} !important;

    &:hover {
      fill: ${(props) => (props.hoverFill ? props.hoverFill : props.fill)};
    }
  }
`
